import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import HomePage from './pages/HomePage';
import QuizPage from './pages/QuizPage';
import ForecastPage from './pages/ForecastPage';
import ForecastResults from './pages/ForecastResults';
import StackFinderPage from './pages/StackFinderPage';
import NadQuizPage from './pages/NadQuizPage';
import SermorelinQuizPage from './pages/SermorelinQuizPage';
import StarterKitPage from './pages/StarterKitPage';
import OptimizePage from './pages/OptimizePage';
import ResultsPage from './pages/ResultsPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import BlogIndex from './pages/BlogIndex';
import BlogPost from './pages/BlogPost';
import AdminBlog from './pages/AdminBlog';
import AdminBlogEditor from './pages/AdminBlogEditor';
import AboutPage from './pages/AboutPage';
import ComparePage, { DirectComparisonPage } from './pages/ComparePage';
import ChatAssistant from './components/ChatAssistant';
import {
  WeightLossTherapy, EnergyTherapy, RecoveryTherapy,
  BodyCompositionTherapy, CognitiveTherapy, SleepTherapy, HormonesTherapy
} from './pages/TherapyCategoryPage';
import { AIProfileProvider } from './context/AIProfileContext';

function AppContent() {
  const location = useLocation();
  
  // Hide chat assistant on admin pages and blog pages
  const showChat = !location.pathname.startsWith('/admin') && !location.pathname.startsWith('/blog');
  
  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/quiz" element={<QuizPage />} />
        <Route path="/forecast" element={<ForecastPage />} />
        <Route path="/forecast/results" element={<ForecastResults />} />
        <Route path="/stack-finder" element={<StackFinderPage />} />
        <Route path="/calculator" element={<ForecastPage />} />
        <Route path="/nad-quiz" element={<NadQuizPage />} />
        <Route path="/sermorelin-quiz" element={<SermorelinQuizPage />} />
        <Route path="/free-starter-kit" element={<StarterKitPage />} />
        <Route path="/optimize" element={<OptimizePage />} />
        <Route path="/results/:leadId" element={<ResultsPage />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/compare" element={<ComparePage />} />
        <Route path="/compare/:slug" element={<DirectComparisonPage />} />
        <Route path="/therapies/weight-loss" element={<WeightLossTherapy />} />
        <Route path="/therapies/energy" element={<EnergyTherapy />} />
        <Route path="/therapies/recovery" element={<RecoveryTherapy />} />
        <Route path="/therapies/body-composition" element={<BodyCompositionTherapy />} />
        <Route path="/therapies/cognitive" element={<CognitiveTherapy />} />
        <Route path="/therapies/sleep" element={<SleepTherapy />} />
        <Route path="/therapies/hormones" element={<HormonesTherapy />} />
        <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/blog" element={<AdminBlog />} />
        <Route path="/admin/blog/new" element={<AdminBlogEditor />} />
        <Route path="/admin/blog/edit/:id" element={<AdminBlogEditor />} />
      </Routes>
      {showChat && <ChatAssistant />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AIProfileProvider>
          <BrowserRouter>
            <AppContent />
          </BrowserRouter>
        </AIProfileProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;